import React from 'react';
import { Input, File } from 'formsy-react-components';
import { jobTypeConstants } from '../../utils';

const {
  DEPOSITION,
  MEDICAL_APPOINTMENT,
  EUO,
  EBT,
  SIMULTANEOUS,
  TRANSLATION
} = jobTypeConstants;

export const ExtraJobInfo = React.createClass({
  getInitialState() {
    const { jobType } = this.props;
    return {
      jobType: jobType
    };
  },

  componentWillReceiveProps(nextProps) {
    if (nextProps.job.get('job_type') !== this.props.job.get('job_type')) {
      return this.setState({
        jobType: nextProps.job.get('job_type')
      });
    }
    return undefined;
  },

  handleChange(event, value) {
    return this.setState({
      jobType: parseInt(value)
    });
  },

  showOptions(jobValue) {
    const { job } = this.props;
    switch (jobValue) {
      case DEPOSITION:
      case EBT:
      case EUO:
        return (
          <div>
            <Input
              label="Job Number"
              type="text"
              name="job_number"
              value={job.get('job_number') || ''}
              placeholder="Job Number"
              labelClassName="small-12"
              elementWrapperClassName="small-12"
            />
            <Input
              label="Case Name"
              type="text"
              name="case_name"
              value={job.get('case_name') || ''}
              placeholder="Case Name"
              labelClassName="small-12"
              elementWrapperClassName="small-12"
            />
            <Input
              label="Witness/Witnesses"
              type="text"
              name="witness_name"
              value={job.get('witness_name') || ''}
              placeholder="Witness Name"
              labelClassName="small-12"
              elementWrapperClassName="small-12"
            />
            <Input
              label="Date of Loss"
              type="date"
              name="date_of_loss"
              value={job.get('date_of_loss') || ''}
              labelClassName="small-12"
              elementWrapperClassName="small-12"
            />
            <Input
              label="Claim Number"
              type="text"
              name="claim_number"
              value={job.get('claim_number') || ''}
              placeholder="Claim Number"
              labelClassName="small-12"
              elementWrapperClassName="small-12"
            />
            <Input
              label="File Number"
              type="text"
              name="file_number"
              value={job.get('file_number') || ''}
              placeholder="File Number"
              labelClassName="small-12"
              elementWrapperClassName="small-12"
            />
            <Input
              label="Questioning Attorney"
              type="text"
              name="questioning_attorney"
              value={job.get('questioning_attorney') || ''}
              placeholder="Questioning Attorney"
              labelClassName="small-12"
              elementWrapperClassName="small-12"
            />
            <Input
              label="Opposing Counsel Attorney Name"
              type="text"
              name="opposing_counsel_attorney_name"
              value={job.get('opposing_counsel_attorney_name') || ''}
              placeholder="Opposing Counsel Attorney"
              labelClassName="small-12"
              elementWrapperClassName="small-12"
            />
            <Input
              label="Opposing Counsel Firm Name"
              type="text"
              name="opposing_counsel_firm_name"
              value={job.get('opposing_counsel_firm_name') || ''}
              placeholder="Opposing Counsel Firm"
              labelClassName="small-12"
              elementWrapperClassName="small-12"
            />
          </div>
        );
      case MEDICAL_APPOINTMENT:
        return (
          <div>
            <Input
              label="Job Number"
              type="text"
              name="job_number"
              value={job.get('job_number') || ''}
              placeholder="Job Number"
              labelClassName="small-12"
              elementWrapperClassName="small-12"
            />
            <Input
              label="Case Name"
              type="text"
              name="case_name"
              value={job.get('case_name') || ''}
              placeholder="Case Name"
              labelClassName="small-12"
              elementWrapperClassName="small-12"
            />
            <Input
              label="Claimant"
              type="text"
              name="witness_name"
              value={job.get('witness_name') || ''}
              placeholder="Claimaint Name"
              labelClassName="small-12"
              elementWrapperClassName="small-12"
            />
            <Input
              label="Date of Loss"
              type="date"
              name="date_of_loss"
              value={job.get('date_of_loss') || ''}
              labelClassName="small-12"
              elementWrapperClassName="small-12"
            />
            <Input
              label="Claim Number"
              type="text"
              name="claim_number"
              value={job.get('claim_number') || ''}
              placeholder="Claim Number"
              labelClassName="small-12"
              elementWrapperClassName="small-12"
            />
            <Input
              label="File Number"
              type="text"
              name="file_number"
              value={job.get('file_number') || ''}
              placeholder="File Number"
              labelClassName="small-12"
              elementWrapperClassName="small-12"
            />
          </div>
        );
      case SIMULTANEOUS:
        return (
          <div>
            <Input
              label="Event Name"
              type="text"
              name="case_name"
              value={job.get('case_name') || ''}
              placeholder="Event Name"
              labelClassName="small-12"
              elementWrapperClassName="small-12"
            />
            <Input
              label="Job Number"
              type="text"
              name="job_number"
              value={job.get('job_number') || ''}
              placeholder="Job Number"
              labelClassName="small-12"
              elementWrapperClassName="small-12"
            />
          </div>
        );
      case TRANSLATION:
        return (
          <div>
            <File
              name="translation_document"
              label="Please upload a file for translation"
              required={!job.get('translation_document_url')}
            />
            {job.get('translation_document_url') ? (
              <a href={job.get('translation_document_url')} target="_blank">
                View current
              </a>
            ) : null}
          </div>
        );
      default:
        return <div>Please Select a Job type</div>;
    }
  },

  render() {
    const { jobType } = this.props;
    return (
      <div className="form-panel">
        <div className="heading">Details</div>
        <hr />
        {this.showOptions(jobType)}
      </div>
    );
  }
});



/** WEBPACK FOOTER **
 ** ./src/components/jobs/extra-job-info.jsx
 **/